import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserVehicleService } from "Bands/services";
import { USER_ACTIONS, IUserVehiclePatchData } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { IStoreState } from "App/types";

export const dispatchGetUserVehicles = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserVehicles({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserVehicles,
    })
  );
};

const getUserVehicles = createAsyncThunk(
  USER_ACTIONS.getUserVehicles,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserVehicleService.getUserVehicles({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userVehicle]: data.userVehicle,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserVehicle = createAsyncThunk(
  USER_ACTIONS.createUserVehicle,
  async (vehicle: IUserVehiclePatchData, { rejectWithValue }) => {
    try {
      const data = await UserVehicleService.createUserVehicle(vehicle);
      const id = Object.values(data?.userVehicle)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserVehicle = createAsyncThunk(
  USER_ACTIONS.editUserVehicle,
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: IUserVehiclePatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      return await UserVehicleService.editUserVehicle(id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserVehicle = createAsyncThunk(
  USER_ACTIONS.deleteUserVehicle,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserVehicleService.deleteUserVehicle(id);
      return {
        path: API_ENDPOINTS.USER_VEHICLE(id),
        dataKey: IDataKeys.userVehicle,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
